import { render, staticRenderFns } from "./ShowHint.vue?vue&type=template&id=31de44e6&scoped=true"
import script from "./ShowHint.vue?vue&type=script&lang=js"
export * from "./ShowHint.vue?vue&type=script&lang=js"
import style0 from "./ShowHint.vue?vue&type=style&index=0&id=31de44e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de44e6",
  null
  
)

export default component.exports